import React, { useEffect, useState } from "react";
import { SelectField, View } from "@aws-amplify/ui-react";
import * as queries from "../../graphql/queries";
import { gql } from "../../lib/gqlClient";

export default function TenantSwitcherCompact({ value, onChange }) {
  const [tenants, setTenants] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        let nt;
        let acc = [];
        do {
          const data = await gql(queries.listTenants, { limit: 500, nextToken: nt });
          const page = data?.listTenants;
          acc = acc.concat(page?.items || []);
          nt = page?.nextToken;
        } while (nt);

        acc.sort((a, b) => String(a?.name || "").localeCompare(String(b?.name || "")));

        if (!cancelled) setTenants(acc);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <View width={{ base: "100%", medium: "18rem" }}>
      <SelectField
        label="Tenant"
        size="small"
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
      >
        {loading ? (
          <option value="">Loading…</option>
        ) : (
          <>
            <option value="">Select tenant…</option>
            {tenants.map((t) => (
              <option key={t.id} value={t.id}>
                {t.name}
              </option>
            ))}
          </>
        )}
      </SelectField>
    </View>
  );
}
